import {Loader} from "@googlemaps/js-api-loader";
import {findNonce} from "./helpers";

/**
 * Find google API key
 *
 * @return {string|boolean}
 */
export function findGoogleAPIKey() {
	const keyElement = document.querySelector('[data-google_map_key]');
	if (!keyElement) {
		return false;
	}

	return keyElement.getAttribute('data-google_map_key')
}

/**
 *
 * @param libraries ['drawing', 'geometry', 'places', 'visualization']
 * @return {Promise|false}
 */
export function loadGoogleAPI(libraries = []) {
	const apiKey = findGoogleAPIKey();

	if (!apiKey) {
		throw new Error('Missing google API key');
	}

	const loader = new Loader({
		apiKey: apiKey,
		version: "weekly",
		libraries: libraries,
		nonce: findNonce(),
	});

	return loader.load();
}